export default __webpack_public_path__ + "static/media/img3.4a4f5210.jpg";